/*
 * Row Usage
 */

export const isRowType = (row, type) => {
	const className = getTypeClassName(type);
	return row.classList.contains(className);
};

export const getRowData = element => {
	const row = element.closest('[data-index]');

	if (!row || isRowType(row, 'search')) {
		return null;
	}

	const innerRow = row.querySelector('.product-row');

	if (!innerRow) {
		return null;
	}

	return {
		vikingSku: row.getAttribute('data-vikingsku'),
		quantity: parseInt(innerRow.getAttribute('data-quantity'), 10),
		index: parseInt(row.getAttribute('data-index'), 10),
	};
};

export const getRowMinMax = element => {
	const row = element.closest('[data-index]');

	if (!row || isRowType(row, 'search')) {
		return null;
	}

	const innerRow = row.querySelector('.product-row');
	const validationElement = row.querySelector('.min-max-values');

	if (!innerRow || !validationElement) {
		return null;
	}

	let min = innerRow.getAttribute('data-min');
	let max = innerRow.getAttribute('data-max');
	min = min ? parseInt(min, 10) : 1;
	max = max ? parseInt(max, 10) : 9999;

	return {
		minOrderQty: min,
		maxOrderQty: max,
		element: validationElement,
		errorClass: 'min-max-values--invalid-qty',
	};
};

export const focusRowInput = row => {
	const quantityInput = row.querySelector('[name="quantity"]');
	quantityInput.focus();
	quantityInput.select();

	return row;
};

export const getRowCount = (wrap, type = false) => {
	if (type) {
		const className = `.${getTypeClassName(type)}`;
		return wrap.querySelectorAll(className).length;
	}

	return wrap.children.length;
};

/*
 * Conditionals
 */

export const isFormSubmission = function (e) {
	return (
		e.type === 'submit' ||
		(e.type === 'focusout' && e.target.name === 'vikingSku')
	);
};

export const isDeleteButton = function (e) {
	return e.type === 'click' && e.target.closest('[name="delete"]') !== null;
};

export const isQuantityUpdate = function (e) {
	return e.type === 'focusout' && e.target.name === 'quantity';
};

/*
 * Forms
 */

export const getFormData = form => {
	const formObj = {};

	for (let i = 0; i < form.elements.length; i += 1) {
		const field = form.elements[i];

		if (field.type !== 'submit') {
			formObj[field.name] = field.value.trim();
		}
	}

	return formObj;
};

export const resetForm = form => {
	for (let i = 0; i < form.elements.length; i += 1) {
		form.elements[i].value = '';
	}

	if (form.classList.contains('has-errors')) {
		const errorField = form.querySelector('.is-invalid');
		const errorMessage = form.querySelector('.form-text-errors');

		errorField.classList.remove('is-invalid');
		errorMessage.parentNode.removeChild(errorMessage);
		form.classList.remove('has-errors');
	}
};

export const setFormButtonsState = (footer, productRows) => {
	const disabledState = productRows < 1;
	const formButtons = footer.querySelectorAll('button');

	if (formButtons.length) {
		for (let i = 0; i < formButtons.length; i += 1) {
			formButtons[i].disabled = disabledState;
		}
	}
};
/*
 * UI Features
 */

export const enableTooltip = row => {
	const tooltips = row.querySelectorAll('.tooltip-wrap');

	if (tooltips.length) {
		const { Tooltip } = window.od;

		for (let i = 0; i < tooltips.length; i += 1) {
			new Tooltip(tooltips[i]);
		}
	}

	return row;
};

export const clearErrorMessages = id => {
	const errors = document.getElementById(id);

	if (errors) {
		errors.parentNode.removeChild(errors);
	}
};

function getTypeClassName(type) {
	return type === 'product'
		? 'quick-order-product-row'
		: 'quick-order-search-row';
}
